import {
  Box,
  Button,
  Chip,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import React, { useState } from 'react';
import CustomDialog from 'src/app/components/CustomDialog';

// Biển số của thiết bị; thiết bị chưa gắn phương tiện thì hiển thị serial
const getPlate = device => device?.vehicle?.license_plate || device?.serial || '--';

function DriverVehiclesCell({ devices, driverName }) {
  const classes = useStyles();
  const [openList, setOpenList] = useState(false);
  const list = Array.isArray(devices) ? devices : [];

  if (list.length === 0) {
    return (
      <Chip size="small" label="Chưa gán xe" className={classes.emptyChip} />
    );
  }

  // Xe chính: ưu tiên thiết bị đã gắn biển số
  const primary = list.find(device => device?.vehicle?.license_plate) || list[0];
  const othersCount = list.length - 1;
  const plateCount = list.filter(device => device?.vehicle?.license_plate).length;

  return (
    <Box className={classes.cell}>
      <span className={classes.plateText}>{getPlate(primary)}</span>
      {othersCount > 0 && (
        <>
          <Chip
            size="small"
            clickable
            label={`+${othersCount} xe khác`}
            className={classes.moreChip}
            onClick={() => setOpenList(true)}
          />
        </>
      )}

      {openList && (
        <CustomDialog
          title="Danh phương tiện"
          open={openList}
          onClose={() => setOpenList(false)}
        >
          <Box className={classes.dialogContent}>
            <Box className={classes.summary}>
              <span className={classes.summaryName}>{driverName || '--'}</span>
              <span className={classes.summaryMeta}>
                {list.length} thiết bị · {plateCount} đã gắn biển số
              </span>
            </Box>

            <Box className={classes.tableBox}>
              <Table size="small" stickyHeader className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell width={48} align="center">STT</TableCell>
                    <TableCell>Biển số</TableCell>
                    <TableCell>Serial</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {list.map((device, index) => (
                    <TableRow key={device.id || index}>
                      <TableCell align="center" className={classes.indexCell}>
                        {index + 1}
                      </TableCell>
                      <TableCell>
                        {device?.vehicle?.license_plate ? (
                          <span className={classes.plateCell}>
                            {device.vehicle.license_plate}
                          </span>
                        ) : (
                          <span className={classes.muted}>Chưa gắn biển số</span>
                        )}
                      </TableCell>
                      <TableCell className={classes.serialCell}>
                        {device?.serial || '--'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>

            <Box className={classes.footer}>
              <Button
                className="btn-main btn-plain"
                color="primary"
                variant="contained"
                onClick={() => setOpenList(false)}
              >
                Đóng
              </Button>
            </Box>
          </Box>
        </CustomDialog>
      )}
    </Box>
  );
}

const useStyles = makeStyles(theme => ({
  cell: {
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },
  plateText: {
    fontWeight: 400,
  },
  moreChip: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.text.secondary,
    fontSize: 12
  },
  emptyChip: {
    backgroundColor: '#fff4e5',
    color: '#b26a00',
    fontSize: 12
  },
  dialogContent: {
    padding: theme.spacing(2, 0, 2.5)
  },
  summary: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: theme.spacing(1.5)
  },
  summaryName: {
    fontSize: 15,
    fontWeight: 600,
    color: '#1f2430'
  },
  summaryMeta: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap'
  },
  tableBox: {
    maxHeight: 360,
    overflowY: 'auto',
    border: '1px solid #e6e8ec',
    borderRadius: 8
  },
  table: {
    '& .MuiTableCell-root': {
      fontSize: 13,
      padding: '9px 12px',
      borderBottom: '1px solid #f0f1f4'
    },
    '& .MuiTableCell-stickyHeader': {
      backgroundColor: '#f7f8fa',
      color: '#6b7080',
      fontWeight: 600,
      fontSize: 12,
      textTransform: 'uppercase',
      letterSpacing: 0.3
    },
    '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
      borderBottom: 'none'
    },
    '& .MuiTableBody-root .MuiTableRow-root:hover': {
      backgroundColor: '#fafbfc'
    }
  },
  indexCell: {
    color: theme.palette.text.secondary
  },
  plateCell: {
    fontWeight: 600,
    color: '#1f2430'
  },
  serialCell: {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
    color: '#4b5060',
    letterSpacing: 0.2
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2.5)
  },
  muted: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic'
  }
}));

export default React.memo(DriverVehiclesCell);
